
const digest = '532b876ca11431ad8e00a6c40de199d5e0601516424a42abf50e9208de2e7a49';
const classes = {"container":"_container_1h0y2_1"};
const css = `._container_1h0y2_1 {
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: flex-end;
  padding: 24px;
  border-bottom: 1px solid #e2e5ed;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  